module.exports = __webpack_public_path__ + "media/images/mail/select-item-btn-d0a44b56687fd3e3faee13de0a7bfb6f.png";